"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _types = require("../../../utils/types");
var _Tweet = _interopRequireDefault(require("./Tweet"));
require("./TwitterView.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var TwitterView = function TwitterView(_ref) {
  var _ref$tweets = _ref.tweets,
    tweets = _ref$tweets === void 0 ? [] : _ref$tweets,
    user = _ref.user;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-twitter-view"
  }, tweets.map(function (tweet, i) {
    return /*#__PURE__*/_react["default"].createElement(_Tweet["default"], {
      key: i,
      tweet: tweet,
      user: user
    });
  }));
};
TwitterView.propTypes = {
  tweets: _propTypes["default"].arrayOf(_types.messageType),
  user: _types.contactType
};
var _default = exports["default"] = TwitterView;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/ConversationView/TwitterView/TwitterView.js
// module id = 1409
// module chunks = 0